import React, { useEffect, useState } from 'react';
import {
  FaBars,
  FaCalendarCheck,
  FaCheckCircle,
  FaEnvelope,
  FaHome,
  FaInfoCircle,
  FaPlane,
  FaUserCircle,
  FaUsers
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

function Sidebar({ isOpen, setIsOpen }) {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isPakageOpen, setIsPakageOpen] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem('travchap_user');
    setIsLoggedIn(!!user);
  }, []);

  const menus = [
    { name: 'Home', icon: <FaHome />, path: '/' },

    {
      name: 'Package',
      icon: <FaCalendarCheck />,
      path: isLoggedIn ? '/pakages' : '/login'
    },

    { name: 'Tasks', icon: <FaCheckCircle /> },
    { name: 'Messages', icon: <FaEnvelope />, path: '/help' },
    { name: 'About Us', icon: <FaInfoCircle />, path: '/about' },

    {
      name: 'Profile',
      icon: <FaUserCircle />,
      path: isLoggedIn ? '/account' : '/login'
    },
    {
      name: 'Round Trip',
      icon: <FaPlane />,
      path: '/round-trip'
    }
  ];

  const categories = [
    { label: 'Domestic Packages', path: '/domestic-form' },
    { label: 'International Packages', path: '/international-form' },
    { label: 'Religious Packages', path: '/religious-form' }
  ];

  return (
    <div
      className={`
        fixed top-0 left-0 h-screen bg-[#40858a] text-white transition-all duration-300 z-40 flex flex-col
        ${isOpen ? 'w-56' : 'w-0 sm:w-16'}
        overflow-hidden
      `}
    >
      <div className="p-4 py-8 flex justify-between items-center mt-4 shadow-md sm:flex">
        <FaBars
          className="cursor-pointer text-2xl"
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>

      <div className="flex flex-col mt-4">
        {menus.map((menu, index) => (
          <div
            key={index}
            onClick={() => navigate(menu.path)}
            className="flex items-center gap-2 h-12 px-5 rounded-md cursor-pointer hover:bg-teal-500 transition-colors"
          >
            <span className="text-xl">{menu.icon}</span>

            <span
              className={`ml-4 text-sm font-medium whitespace-nowrap transition-opacity duration-300 ${
                isOpen ? 'opacity-100' : 'opacity-0 sm:opacity-100'
              }`}
            >
              {menu.name}
            </span>
          </div>
        ))}
      </div>
      <div className="relative sm:hidden" onClick={() => setIsPakageOpen(true)}>
        <div className="flex items-center font-bold text-sm gap-2 cursor-pointer px-3 py-2 hover:text-pink-600">
          <FaUsers />
          <h2>Group Pakage Request</h2>
        </div>

        {isPakageOpen && (
          <div className="absolute left-0 w-60 shadow-lg rounded-lg z-50">
            <ul className="flex flex-col">
              {categories.map((cat, index) => (
                <li
                  key={index}
                  onClick={() => navigate(cat.path)}
                  className="px-4 py-2 hover:bg-pink-100 cursor-pointer  hover:text-black text-white"
                >
                  {cat.label}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default Sidebar;
